export function buildPreEmissionAudit(input = {}) {
  const weakPct = Number(input?.weakIndexPct || 0)
  const invalidRows = Number(input?.invalidIndexRows || 0)
  const traceabilityComplete = Boolean(input?.traceabilityComplete)
  const integrityBlocking = Boolean(input?.integrityBlocking)
  const legalConsistencyBlocking = Boolean(input?.legalConsistencyBlocking)
  const criticalAlerts = Number(input?.criticalAlerts || 0)
  const topeGlobalAudit = input?.topeGlobalAudit || null
  const topeGlobalConfiscatorio = Boolean(topeGlobalAudit?.inaplicablePorConfiscatoriedad)
  const serieTemporalIncompleta = Boolean(input?.serieTemporalIncompleta)
  const docenteConfigBlocking = Boolean(input?.docenteConfigBlocking)
  const integrityStatus = String(input?.integrityStatus || '').toLowerCase()
  const integrityReasonCodes = Array.isArray(input?.integrityReasonCodes) ? input.integrityReasonCodes : []

  const reasons = []
  let color = 'verde'

  if (invalidRows > 0 || !traceabilityComplete || integrityBlocking || legalConsistencyBlocking || criticalAlerts > 0 || topeGlobalConfiscatorio || serieTemporalIncompleta || docenteConfigBlocking) {
    color = 'rojo'
  } else if (weakPct > 20) {
    color = 'ambar'
  }

  if (invalidRows > 0) reasons.push(`Indices invalidos en base legal: ${invalidRows} filas.`)
  if (!traceabilityComplete) reasons.push('Trazabilidad incompleta en version normativa/indices/fecha de corte.')
  if (integrityBlocking) reasons.push('Integridad laboral con hallazgos bloqueantes.')
  if (legalConsistencyBlocking) reasons.push('Consistencia juridica final con observaciones bloqueantes.')
  if (criticalAlerts > 0) reasons.push(`Alertas criticas detectadas: ${criticalAlerts}.`)
  if (weakPct > 20) reasons.push(`Calidad de indices degradada: ${weakPct}% con fallback fuerte.`)
  if (topeGlobalConfiscatorio) reasons.push(`Tope global potencialmente confiscatorio: quita ${Number(topeGlobalAudit?.quitaPct || 0).toFixed(2)}% (doctrina ${String(topeGlobalAudit?.doctrinaSugerida || 'Tual / Actis Caporale')}).`)
  if (serieTemporalIncompleta) reasons.push('[WARN] Serie temporal incompleta para el mes en curso. Se requiere actualización de tablas oficiales.')
  if (docenteConfigBlocking) reasons.push('Caso configurado como Especial Docente pero carece de la informacion del cargo al cese requerida por el Dec. 137/05')

  let status = 'ok'
  if (color === 'rojo') status = 'blocking'
  else if (color === 'ambar') status = 'warning'
  if (status === 'ok' && integrityStatus === 'yellow') status = 'warning'

  let primaryReason = 'sin_hallazgos_bloqueantes'
  if (integrityBlocking) {
    primaryReason = integrityReasonCodes[0] || 'integridad_laboral_bloqueante'
  } else if (integrityStatus === 'yellow') {
    primaryReason = integrityReasonCodes[0] || 'integridad_laboral_warning'
  } else if (weakPct > 20) {
    primaryReason = 'calidad_indices_degradada'
  }

  return {
    color,
    allowAdvancedDictamen: color !== 'rojo',
    status,
    primaryReason,
    diagnostics: {
      integrityStatus,
      integrityReasonCodes,
    },
    reasons,
    topeGlobalAudit,
  }
}
